import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { ActionOption } from 'types';
import LwtTable from 'components/@common/Table/LwtTable';

interface RequiredRowDataProps {
  id: number;
  ExpansionComponent?: React.ReactNode;
}
interface ListViewContainerProps<T> {
  rowData: Array<T & RequiredRowDataProps>;
  columns: any[];
  actionOptions?: Array<ActionOption>;
  onRowClick?: (item: T, idx: number) => void;
  children?: React.ReactNode;
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    table: {
      maxWidth: 'unset !important'
    },
    tableBody: {
      background: 'white'
    },
    tableRow: {
      width: 30
    },
    container: {
      paddingTop: theme.spacing(1),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      marginBottom: theme.spacing(8)
    },
    downIcon: {
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.shortest
      })
    },
    downIconRotate: {
      transform: 'rotate(180deg)',
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.shortest
      })
    }
  };
});

function ListViewContainer<T>({
  rowData,
  columns,
  onRowClick
}: ListViewContainerProps<T>): React.ReactElement {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <LwtTable
        onRowClick={onRowClick}
        columns={columns}
        data={rowData}
        options={{ checkbox: false, sortable: true }}
        classes={{
          table: (): string => classes.table,
          body: (): string => classes.tableBody,
          row: (): string => classes.tableRow
        }}
        rowProps={(item, index) => ({
          style: {
            borderLeft: `10px solid ${item?.color}`
          }
        })}
      />
    </div>
  );
}

export default ListViewContainer;
